import { createAction } from 'lib/store-utils';
import { ServerUserCurrent, ServerUserFields } from 'type';

export const BOX_AUTH_LOGOUT_REQUEST = createAction('Auth / Logout request');

export const BOX_AUTH_GET_GLOBAL_DATA_REQUEST = createAction('Auth / Get global data request');

export const BOX_AUTH_GET_CURRENT_USER_SUCCESS = createAction<ServerUserCurrent>('Auth / Get current user success');
export const BOX_AUTH_UPDATE_CURRENT_USER_DATA = createAction<Partial<ServerUserFields>>('Auth / Update current user data');
